var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF0000",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 26C14.79 26 13 27.79 13 30C13 32.21 14.79 34 17 34C19.21 34 21 32.21 21 30C21 27.79 19.21 26 17 26ZM18 29.68C18 30.29 17.67 30.87 17.15 31.18L16.39 31.64C16.27 31.72 16.13 31.75 16 31.75C15.75 31.75 15.5 31.62 15.36 31.39C15.15 31.04 15.26 30.57 15.62 30.36L16.38 29.9C16.45 29.86 16.5 29.77 16.5 29.69V28.76C16.5 28.34 16.84 28 17.25 28C17.66 28 18 28.34 18 28.75V29.68Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16H19C16 16 14 17.5 14 21V24.56C14 24.93 14.38 25.16 14.71 25.01C15.69 24.56 16.82 24.39 18.01 24.6C20.64 25.07 22.57 27.51 22.5 30.18C22.49 30.6 22.43 31.01 22.32 31.41C22.24 31.72 22.49 32.01 22.81 32.01H29C32 32.01 34 30.51 34 27.01V21C34 17.5 32 16 29 16ZM24 26.5C22.62 26.5 21.5 25.38 21.5 24C21.5 22.62 22.62 21.5 24 21.5C25.38 21.5 26.5 22.62 26.5 24C26.5 25.38 25.38 26.5 24 26.5ZM31.25 26C31.25 26.41 30.91 26.75 30.5 26.75C30.09 26.75 29.75 26.41 29.75 26V22C29.75 21.59 30.09 21.25 30.5 21.25C30.91 21.25 31.25 21.59 31.25 22V26Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledTransactionsIcon);
export default __webpack_public_path__ + "static/media/cancelled-transactions-icon.b148e0c3ee9e68d84356087fcf1ca503.svg";
export { ForwardRef as ReactComponent };